import { epicRequest } from 'app'

export const LINEUPS_FETCH = 'LINEUPS_FETCH'
export const LINEUPS_FETCH_CANCELED = 'LINEUPS_FETCH_CANCELED'
export const LINEUPS_FETCH_ERROR = 'LINEUPS_FETCH_ERROR'
export const LINEUPS_FETCH_FULFILLED = 'LINEUPS_FETCH_FULFILLED'

export const LINEUPS_INITIAL_STATE = {
  data: [],
  error: null,
  loaded: false,
  pagination: null,
}

export const lineupsFetch = (id) => ({
  payload: { id },
  type: LINEUPS_FETCH,
})

export const lineupsFetchFulfilled = (payload) => ({
  payload,
  type: LINEUPS_FETCH_FULFILLED,
})

export const lineupsFetchCanceled = () => ({
  payload: null,
  type: LINEUPS_FETCH_CANCELED,
})

export const lineupsFetchError = (payload) => ({
  payload,
  type: LINEUPS_FETCH_ERROR,
})

export const lineupsFetchEpic = epicRequest({
  actionType: LINEUPS_FETCH,
  errorAction: lineupsFetchError,
  fulfilledAction: lineupsFetchFulfilled,
  request: ({ payload }) => `sports/soccer/match/${payload.id}/lineup`,
  untilTypes: LINEUPS_FETCH_CANCELED,
})
